"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const legacyVars_1 = require("../plugins/gtm/legacyVars");
exports.default = vue_1.default.extend({
    name: 'FrkGtmTracking',
    mounted() {
        this.$auth.$watch('loggedUser', loggedUser => {
            if (loggedUser) {
                if (this.$auth.isFreelance) {
                    vue_1.default.$gtm.trackUserVar(legacyVars_1.GTM_LEGACY_VAR_VISITOR_TYPE, legacyVars_1.GTM_LEGACY_VAR_VISITOR_TYPE_FREELANCE);
                    vue_1.default.$gtm.trackUserVar(legacyVars_1.GTM_LEGACY_VAR_VISITOR_LOCATION, loggedUser.freelance?.geographicAvailability?.address?.city);
                    vue_1.default.$gtm.trackFreelanceVar(legacyVars_1.GTM_LEGACY_VAR_FREELANCE_PRICE, loggedUser.freelance?.price?.target);
                    vue_1.default.$gtm.trackFreelanceVar(legacyVars_1.GTM_LEGACY_VAR_FREELANCE_JOB, loggedUser.title);
                }
                if (this.$auth.isClient) {
                    vue_1.default.$gtm.trackUserVar(legacyVars_1.GTM_LEGACY_VAR_VISITOR_TYPE, legacyVars_1.GTM_LEGACY_VAR_VISITOR_TYPE_CLIENT);
                    vue_1.default.$gtm.trackUserVar(legacyVars_1.GTM_LEGACY_VAR_VISITOR_LOCATION, loggedUser.company?.address?.city);
                }
                vue_1.default.$gtm.trackUserVar(legacyVars_1.GTM_LEGACY_VAR_VISITOR_ID, loggedUser._id);
                vue_1.default.$gtm.trackUserVar(legacyVars_1.GTM_LEGACY_VAR_VISITOR_LOGGING_STATE, legacyVars_1.GTM_LEGACY_VAR_VISITOR_LOGGING_STATE_LOGGED);
                vue_1.default.$gtm.isSynced();
            }
            else {
                vue_1.default.$gtm.trackUserVar(legacyVars_1.GTM_LEGACY_VAR_VISITOR_LOGGING_STATE, legacyVars_1.GTM_LEGACY_VAR_VISITOR_LOGGING_STATE_UNLOGGED);
            }
        });
    },
    render() {
        return null;
    },
});
